import React from "react";

function BoxArrowUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M5.227 4.898a.562.562 0 00.796 0L9 1.92l2.977 2.978a.563.563 0 10.796-.796L9.398.727a.563.563 0 00-.796 0L5.227 4.102a.562.562 0 000 .796z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M9 12.938a.563.563 0 00.563-.563V2.25a.563.563 0 10-1.126 0v10.125a.562.562 0 00.563.563z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#6C757D"
        fillRule="evenodd"
        d="M2.813 15.75A1.687 1.687 0 004.5 17.438h9a1.687 1.687 0 001.688-1.688V7.875A1.687 1.687 0 0013.5 6.187h-1.688a.562.562 0 100 1.125H13.5a.562.562 0 01.563.563v7.875a.562.562 0 01-.563.563h-9a.563.563 0 01-.563-.563V7.875a.563.563 0 01.563-.563h1.688a.563.563 0 100-1.125H4.5a1.687 1.687 0 00-1.688 1.688v7.875z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default BoxArrowUp;
